export default __webpack_public_path__ + "static/media/gloves_of_the_farseeker.aedec58f.jpg";